class PreventScroll {
    static preventDefault(e) {
        e.preventDefault();
    }

    static preventDefaultForScrollKeys(e) {
        // left: 37, up: 38, right: 39, down: 40,
        // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
        if (e.keyCode >= 37 && e.keyCode <= 40) {
            e.preventDefault();
            return false;
        }

        return true;
    }

    static getOpt() {
        // modern Chrome requires { passive: false } when adding event
        let supportsPassive = false;
        try {
            window.addEventListener(
                'test',
                null,
                Object.defineProperty({}, 'passive', {
                    get() {
                        supportsPassive = true;
                        return true;
                    },
                }),
            );
        } catch (e) {
            // Do nothing
        }

        const wheelOpt = supportsPassive ? { passive: false } : false;
        const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

        return { wheelEvent, wheelOpt };
    }

    // // call this to Disable
    static disableScroll() {
        const { wheelEvent, wheelOpt } = PreventScroll.getOpt();

        window.addEventListener('DOMMouseScroll', PreventScroll.preventDefault, false); // older FF
        window.addEventListener(wheelEvent, PreventScroll.preventDefault, wheelOpt); // desktop
        window.addEventListener('touchmove', PreventScroll.preventDefault, wheelOpt); // mobile
        window.addEventListener('keydown', PreventScroll.preventDefaultForScrollKeys, false);
    }

    // // call this to Enable
    static enableScroll() {
        const { wheelEvent, wheelOpt } = PreventScroll.getOpt();

        window.removeEventListener('DOMMouseScroll', PreventScroll.preventDefault, false);
        window.removeEventListener(wheelEvent, PreventScroll.preventDefault, wheelOpt);
        window.removeEventListener('touchmove', PreventScroll.preventDefault, wheelOpt);
        window.removeEventListener('keydown', PreventScroll.preventDefaultForScrollKeys, false);
    }
}

export default PreventScroll;
